import { useEffect } from 'react';
import { vscodeTheme } from '../../styles/theme';

export type ContextMenuItem = {
  label: string;
  onClick: () => void;
  separator?: boolean;
  disabled?: boolean;
};

interface ContextMenuProps {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}

export function ContextMenu({ x, y, items, onClose }: ContextMenuProps) {
  useEffect(() => {
    const handleClick = () => onClose();
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div
      style={{
        position: 'fixed',
        top: y,
        left: x,
        backgroundColor: vscodeTheme.colors.contextMenuBackground,
        border: `1px solid ${vscodeTheme.colors.contextMenuBorder}`,
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
        minWidth: '200px',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {items.map((item, index) =>
        item.separator ? (
          <div
            key={index}
            style={{
              height: '1px',
              backgroundColor: vscodeTheme.colors.contextMenuBorder,
              margin: '4px 0',
            }}
          />
        ) : (
          <div
            key={index}
            onClick={item.disabled ? undefined : item.onClick}
            style={{
              padding: '8px 12px',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              color: item.disabled
                ? vscodeTheme.colors.textSecondary
                : vscodeTheme.colors.textPrimary,
              opacity: item.disabled ? 0.5 : 1,
              fontSize: vscodeTheme.typography.fontSize,
              fontFamily: vscodeTheme.typography.fontFamily,
            }}
            onMouseEnter={(e) => {
              if (!item.disabled) {
                e.currentTarget.style.backgroundColor =
                  vscodeTheme.colors.hoverBackground;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {item.label}
          </div>
        )
      )}
    </div>
  );
}
